import { isSalesDemoEnv } from 'app/settings/defaultSetting'
import Button from 'core/components/buttons/Button'
import PopConfirm from 'core/components/dialogs/PopConfirm'
import Icon from 'core/components/icons/Icon'
import { useUserProfile } from 'core/hooks/data/useDataHook'
import useSalesDemoSandbox from 'core/hooks/sales/useSalesDemoSandbox'
import { isItDemoAccount, isItDemoAdminAccount } from './utils'

const SalesTab = () => {
  const { data: user } = useUserProfile()

  const {
    isWaitingJob,
    mutationQuery: { mutate }
  } = useSalesDemoSandbox()

  const email = user?.email ?? ''

  const isDemoAdminAccount = isItDemoAdminAccount(email)

  if (isSalesDemoEnv === false || !isItDemoAccount(email)) return null

  return (
    <div>
      <p className="text-base text mt-3">Reset your demo data accounts.</p>
      <br />
      <hr />
      <div className="flex justify-between items-center mt-5">
        <span className="font-semibold text-lg">
          Sales Demo{' '}
          {isDemoAdminAccount === false && (
            <>
              :{' '}
              <span className="font-normal text-warning">
                only the demo admin account can reset the data
              </span>
            </>
          )}
        </span>
        {isDemoAdminAccount && (
          <PopConfirm
            onConfirm={() => {
              mutate()
            }}
            disabled={isWaitingJob}
          >
            <Button
              variant="primary"
              className="flex items-center gap-1 select-none"
              prefix={isWaitingJob ? <Icon name="loading" /> : undefined}
              disabled={isWaitingJob}
            >
              Reset Demo Data
            </Button>
          </PopConfirm>
        )}
      </div>
    </div>
  )
}

export default SalesTab
